module.exports = __webpack_public_path__ + "static/media/Brazil.9b702eec.jpg";